import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { makeAutoObservable, toJS } from 'mobx'
import { MDBBtn, MDBAlert } from 'mdbreact'
import { UserFactory, StripeCustomerFactory } from './../../../shared/factories'
import UserProfileService from './../../../shared/services/UserProfile.service'

class CorpEmailSubscriberStore {
  userId = null
  User = null
  Customer = null
  CorpEmail = null

  constructor() {
    makeAutoObservable(this)
  }

  setCustomer = async (userId) => {
    if ((this.userId = userId && !isNaN(userId) ? userId : false)) {
      let customers = null
      try {
        customers =
          (await StripeCustomerFactory.search({ search: { user_id: userId } }))
            ?.models || []
      } catch (ex) {
        console.log('Unable to search customers ', ex)
        customers = []
      }

      let customer = customers
        .filter((c) => c.get('sub_class') === 'sig_agent')
        .shift()
      customer = customer ? customer : customers.shift()
      // get the stripe customer by ID to expand it's properties on response.
      customer = customer
        ? await StripeCustomerFactory.findById(customer.id())
        : false

      if (!customer) {
        // create customer.
        // not needed.
        // user is directed to billing & benefits
        // page to create payment method.
      }

      return (this.Customer = customer)
    }

    return false
  }

  getCustomer = () => this.Customer && this.Customer?.get('expands')?.customer

  getPaymentMethods = () =>
    this.Customer && this.Customer?.get('expands')?.paymentMethod

  getDefaultPaymentMethod = () => {
    let defaultId = toJS(this.getCustomer())?.invoice_settings
      ?.default_payment_method
    let defaultPm = (toJS(this.getPaymentMethods()) || [])
      .filter((pm) => pm.id === defaultId)
      .shift()
    if (defaultPm && typeof defaultPm === 'string') return JSON.parse(defaultPm)
    return defaultPm && typeof defaultPm === 'object' ? defaultPm : false
  }

  getCorpEmail = async () => {
    if (this.userId) {
      // If the user isnt set, or doesnt match the userId, fetch the user instance.
      // we will use this to check for existance of corp email.
      if (!this.User || `${this.User?.id()}` !== `${this.userId}`)
        this.User = await UserFactory.findById(this.userId)

      // with the user instance, check all email addresses for a usabg.com or
      // usabg.net email address.
      if (this.User) {
        // since an usabg.com / usabg.net email address was not located (deprecated)
        // check for the existance of UserCorpEmail.
        const CorpEmail = (
          (await this.User.corpEmail(true).all()) || []
        ).shift()
        return CorpEmail
        // this.CorpEmail = CorpEmail;
        // if (this.CorpEmail && this.CorpEmail.get('email'))
        //   return this.CorpEmail.get('email')
      }
    }

    return false
  }

  canDowngrade = async () =>
    !!(
      this.CorpEmail?.get('sub_status') &&
      !['active'].includes(this.CorpEmail.get('sub_status'))
    )
}

const Store = new CorpEmailSubscriberStore()

const CorpEmailSubscriber = ({
  User,
  isSubscribing,
  onSubscribe,
  onObtain,
  hasPurchased,
  onUnsubscribe,
  isUnsubscribing,
  hasUnsubscribed,
}) => {
  const userId = User && User?.id(),
    { setCustomer, getDefaultPaymentMethod, getCorpEmail, canDowngrade } =
      Store,
    [paymentMethod, setPaymentMethod] = useState(null),
    [UserCorpEmail, setUserCorpEmail] = useState(null)

  onSubscribe = onSubscribe ? onSubscribe : () => {}
  onUnsubscribe = onUnsubscribe ? onUnsubscribe : () => {}

  const renderPaymentDetails = () => {
    if (paymentMethod) {
      return (
        <div className="default-payment-method">
          <table width="100%">
            <thead>
              <tr>
                <th>Payment Method:</th>
                <th>Last 4:</th>
                <th>Exp:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {paymentMethod.card.brand.charAt(0).toUpperCase()}
                  {paymentMethod.card.brand.substr(1)}
                </td>
                <td>{paymentMethod.card.last4}</td>
                <td>
                  {paymentMethod.card.exp_month}/{paymentMethod.card.exp_year}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    }

    if (paymentMethod === false) return <>You have no payment methods.</>

    return <>Loading your payment methods</>
  }

  const renderSubscriptionForm = () => {
    return (
      <div id="CorpEmailSubscriberComponent">
        {renderPaymentDetails()}
        <MDBBtn
          size="sm"
          block
          color="info"
          disabled={hasPurchased || isSubscribing || !paymentMethod}
          onClick={() => onSubscribe()}
        >
          {hasPurchased ? (
            'Email Purchase Complete!'
          ) : !isSubscribing ? (
            'Purchase USABG Corporate Email'
          ) : (
            <>
              Subscribing <i className="fa fa-spin fa-spinner"></i>
            </>
          )}
        </MDBBtn>
        {UserProfileService.isA(['system-admin', 'internal-admin'], true) ? (
          <MDBBtn
            size="sm"
            block
            color="warning"
            disabled={hasPurchased || isSubscribing || !paymentMethod}
            onClick={() => onObtain()}
            className="mt-1"
          >
            {hasPurchased ? (
              'Email Setup Complete!'
            ) : !isSubscribing ? (
              'Obtain USABG Corporate Email'
            ) : (
              <>
                Obtaining <i className="fa fa-spin fa-spinner"></i>
              </>
            )}
          </MDBBtn>
        ) : (
          <></>
        )}
      </div>
    )
  }

  const renderSubscriptionExists = () => {
    return (
      <div id="CorpEmailSubscriberComponent">
        <MDBAlert color="success">
          You currently have an active corporate email subscription for the
          email '<strong>{UserCorpEmail.get('email')}</strong>'.
        </MDBAlert>

        {canDowngrade() ? (
          <MDBBtn
            disabled={isUnsubscribing || hasUnsubscribed}
            size="sm"
            block
            onClick={() => onUnsubscribe(Store.CorpEmail)}
          >
            {isUnsubscribing
              ? 'Unsubscribing ...'
              : 'Unsubscribe & Delete USABG Corporate Email'}
          </MDBBtn>
        ) : (
          <MDBBtn
            disabled={isUnsubscribing}
            size="sm"
            block
            onClick={() => onUnsubscribe(false)}
          >
            {isUnsubscribing
              ? 'Unsubscribing ...'
              : 'Request BST to remove USABG Corporate Email'}
          </MDBBtn>
        )}
      </div>
    )
  }

  const renderInactiveSubscriptionExists = () => {
    return (
      <div id="CorpEmailSubscriberComponent">
        <MDBAlert color="warning">
          You have an in-active corporate email subscription for the email '
          <strong>{UserCorpEmail.get('email')}</strong>'.
        </MDBAlert>
        {renderPaymentDetails()}
        <MDBBtn
          size="sm"
          block
          color="info"
          disabled={hasPurchased || isSubscribing || !paymentMethod}
          onClick={() => onSubscribe()}
        >
          {hasPurchased ? (
            'Email Purchase Complete!'
          ) : !isSubscribing ? (
            'Purchase USABG Corporate Email'
          ) : (
            <>
              Subscribing <i className="fa fa-spin fa-spinner"></i>
            </>
          )}
        </MDBBtn>
        {UserProfileService.isA(['system-admin', 'internal-admin'], true) ? (
          <MDBBtn
            size="sm"
            block
            color="warning"
            disabled={hasPurchased || isSubscribing || !paymentMethod}
            onClick={() => onObtain()}
            className="mt-1"
          >
            {hasPurchased ? (
              'Email Setup Complete!'
            ) : !isSubscribing ? (
              'Obtain USABG Corporate Email'
            ) : (
              <>
                Obtaining <i className="fa fa-spin fa-spinner"></i>
              </>
            )}
          </MDBBtn>
        ) : (
          <></>
        )}
      </div>
    )
  }

  useEffect(() => {
    if (userId)
      setCustomer(userId).finally(() => {
        getCorpEmail().then((UserCorpEmail) => setUserCorpEmail(UserCorpEmail))
        setPaymentMethod(getDefaultPaymentMethod())
      })
  }, [userId, getDefaultPaymentMethod, setCustomer])

  if (paymentMethod === false)
    return (
      <div id="CorpEmailSubscriberComponent">
        <MDBAlert color="warning">
          Please go to the <a href="/account-billinginfo">Billing & Benefits</a>{' '}
          page to update your payment method.
        </MDBAlert>
      </div>
    )

  if (!hasUnsubscribed && ['active'].includes(UserCorpEmail?.get('sub_status')))
    return renderSubscriptionExists()

  if (
    !hasUnsubscribed &&
    UserCorpEmail?.get('sub_status') &&
    UserCorpEmail?.get('subscription_id') &&
    UserCorpEmail?.get('email')
  )
    return renderInactiveSubscriptionExists()

  if (paymentMethod) return renderSubscriptionForm()

  return (
    <div id="CorpEmailSubscriberComponent">
      <MDBAlert>Checking your corporate email status...</MDBAlert>
    </div>
  )
}

export default observer(CorpEmailSubscriber)
